import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/shared.service';
import swal from 'sweetalert';

@Component({
  selector: 'app-employee-view-edit',
  templateUrl: './employee-view-edit.component.html',
  styleUrls: ['./employee-view-edit.component.scss']
})
export class EmployeeViewEditComponent implements OnInit {

  constructor(private service: SharedService) { }


  @Input() Date: any;
  @Input() employee: any;
  @Input() attendanceList: any;
  @Input() clockifyList: any;

  clockify: any;
  attendance: any;
  employeeName: any;
  Arrival: any;
  Departure: any;

  Leave: any;
  Type: any;
  requestType: any = 'Casual';
  typeComments: string = '';
  timeComments: string = '';

  time: any;

  clockifyHours: any;

  isCollapsedChange = true;
  isCollapsedType = true;
  isCollapsedTime = true;


  ngOnInit(): void
  {
    // this.GetAttendance(this.Date, this.employee.pkEmpId);
    this.GetClockify(this.Date, this.employee.ClockifyId);
    this.GetLeave();
    // this.employeeName = this.employee.FirstName.concat(' ', this.employee.LastName);
    this.GetVariables();
    this.RefreshType();
  }


  Test()
  {
    var temp = new Date(this.Date+'Z').toISOString().split('T')[0];
    console.log(this.Date);
    console.log(temp);
  }


  GetVariables()
  {
    if (this.IsTechnical())
    {
        this.clockifyHours = this.clockify?.DurationInMinutes;
        this.RefreshType();
    }
    else
    {
      if(!this.CheckLeave())
      {
        this.Arrival = this.attendance.Arrival;
        this.Departure = this.attendance.Departure;
      }
    }
  }


  GetClockify(date: any, clockifyId: any)
  {
    for(var clockify of this.clockifyList)
    {
      if(clockify.ClockifyId == clockifyId)
      {
        if(clockify.Date == date)
        {
          this.clockify = clockify;
          return
        }
      }
    }
  }


  RefreshType()
  {
    setTimeout(() =>
    {
      this.Type = this.Leave?.Type;
    }, 200);
  }


  IsTechnical()
  {
    if (this.employee.ClockifyId == '')
    {
      return false
    }
    else
    {
      return true
    }
  }


  GetLeave()
  {
    this.service.GetEmployeeLeaveForDay(this.employee.pkEmpId, this.Date).subscribe(data =>
    {
      this.Leave = data[0];
    });
  }


  CheckLeave()
  {
    if (this.IsTechnical())
    {
      if(this.clockify?.WorkHours == undefined)
      {
        return true
      }
      else
      {
        return false
      }
    }
    else
    {
      if (this.attendance?.WorkHours == undefined)
      {
        return true
      }
      else
      {
        return false
      }
    }
  }


  ToggleType()
  {
    this.isCollapsedType = !this.isCollapsedType
    if (!this.isCollapsedTime)
    {
      this.isCollapsedTime = !this.isCollapsedTime;
    }
  }


  ToggleTime()
  {
    this.isCollapsedTime = !this.isCollapsedTime
    if (!this.isCollapsedType)
    {
      this.isCollapsedType = !this.isCollapsedType;
    }
  }


  SendTypeRequest()
  {
    var val =
    {
      fkEmpId: this.employee.pkEmpId,
      Type: "Type",
      PreviousValue: this.Leave.Type,
      RequestedValue: this.requestType,
      Comments: this.typeComments,
      Date: new Date(this.Date+'Z').toISOString().split('T')[0],
      Status: 'Pending',
      DateRequested: new Date(),
    }
    if (val.PreviousValue == val.RequestedValue)
    {
      swal
      ({
        title: "Incorrect Request",
        text: "You are requesting for the same leave as already marked",
        icon: "error",
        buttons:
        {
          confirm: true
        },
        dangerMode: true,
      })
    }
    else
    {
      swal
      ({
        title: "Are you sure?",
        text: "Please double check your request",
        icon: "info",
        buttons:
        {
          cancel: true,
          confirm: true,
        },
        dangerMode: true,
      })
      .then((confirm) =>
      {
        if (confirm)
        {
          this.service.AddChangeRequest(val).subscribe(data =>
          {
            console.log(data)
          });
          swal("SUCCESS", "Request has been sent", "success")
        }
      });
    }
  }


  SendTimeRequest()
  {
    var val =
    {
      fkEmpId: this.employee.pkEmpId,
      Type: "Time",
      PreviousValue: "-",
      RequestedValue: "-",
      Comments: this.timeComments,
      Date: new Date(this.Date+'Z').toISOString().split('T')[0],
      Status: 'Pending',
      DateRequested: new Date(),
    }
    swal
    ({
      title: "Are you sure?",
      text: "Please make sure you've made changes to clockify before requesting this change",
      icon: "warning",
      buttons:
      {
        cancel: true,
        confirm: true,
      },
      dangerMode: true,
    })
    .then((confirm) =>
    {
      if (confirm)
      {
        this.service.AddChangeRequest(val).subscribe(data =>
        {
          console.log(data)
        });
        swal("SUCCESS", "Request has been sent", "success")
      }
    });
  }



}
